<template>
    <div class="fw-choose">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="fw-fjs">
            <div class="fw-fjs-item" v-for="item in rooms" @click="toBilling(item)">
                    <img src="../../assets/kdlist.png" class="fwhbg" >
                    <div class="xinxi">
                        <span class="fwh">服务号</span>
                        <span class="fjm">{{item.roomName}}</span>
                        <span class="fj-btn">点击开单</span>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '选择服务号',
                deptId: '',
                fwUser: {},
                rooms: [],
                str:'',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            if(this.$route.query.memberId){
                this.str='&memberId='+this.$route.query.memberId
            }
            if(this.$route.query.cardId){
                this.str=this.str+'&cardId='+this.$route.query.cardId
            }
            this.getFwRooms()
        },
        methods: {
            async getFwRooms() {
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/fw/getFwRooms", data)
                this.rooms = res.list
            },
            toBilling(item) {
                this.$router.push('/mdBilling?roomId=' + item.id+this.str)
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-choose {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
    }

    .fw-fjs {
        display: flex;
        flex-flow: row wrap;
        padding: 0px 7px;
        /*justify-content: space-between;*/
    }

    .fw-fjs-item {
        /*flex: 1;*/
        box-sizing: border-box;
        margin: 10px 1%;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc((94%) / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((94%) / 3);
        max-width: calc((94%) / 3);
        &:nth-child(3n + 3) {
            margin-right: 0;
        }
        position: relative;
    }
    .fwhbg{
        width: 100%;
        height: 100%;
    }
    .xinxi{
        position:absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 10px;
        height: 100%;
    }
    .fwh{
        font-size: 13px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        padding-top: 10px;

    }
    .fjm {
        font-size: 17px;
        height: 70px;
        text-align: center;
        line-height: 80px;
        color: #F69DA3;
    }

    .fj-btn {
        font-size: 13px;
        text-align: center;
        padding: 5px;
    }

</style>
